import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { SideMenuComponent } from './layout/side-menu/side-menu.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';

type ThemeMode = 'tds-mode-light' | 'tds-mode-dark';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TegelModule,
    HeaderComponent,
    SideMenuComponent,
    FooterComponent,
    SpinnerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  
  mobileNavOpen = signal(false);
  mode = signal<'tds-mode-light' | 'tds-mode-dark'>('tds-mode-light');

  private mediaQuery?: MediaQueryList;
  private readonly THEME_STORAGE_KEY = 'app-theme-preference';

  async ngOnInit() {    
    this.initThemeDetection();
  }

  // #region Dark Theme Monitor

    private initThemeDetection() {
      if (typeof window !== 'undefined' && window.matchMedia) {
        this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        /** Verifies if there's a preferred there and saves om localStorage */
        const savedTheme = this.getSavedTheme();

        if (savedTheme) {
          /** Use saved theme */
          this.mode.set(savedTheme);
        } else {
          /** If there isn't a preferred theme, uses system's default theme */
          this.setThemeFromMediaQuery(this.mediaQuery.matches);
        }

        /** Escuta mudanças no tema do sistema (só aplica se não houver preferência manual) */
        this.mediaQuery.addEventListener('change', this.handleThemeChange);
      }
    }

    /** Handles theme change */
    private handleThemeChange = (e: MediaQueryListEvent) => {
      /** Only applies automatic chenge if there isn't a manual preference saved */
      const savedTheme = this.getSavedTheme();
      if (!savedTheme) {
        this.setThemeFromMediaQuery(e.matches);
      }
    };

    /** Sets user's preferred theme */
    private setThemeFromMediaQuery(isDark: boolean) {
      this.mode.set(isDark ? 'tds-mode-dark' : 'tds-mode-light');
    }

    /** Gets what theme user's currently using */
    private getSavedTheme(): ThemeMode | null {
      if (typeof window !== 'undefined' && window.localStorage) {
        const saved = localStorage.getItem(this.THEME_STORAGE_KEY);
        // Validates if saved value is a valid theme
        if (saved === 'tds-mode-light' || saved === 'tds-mode-dark') {
          return saved;
        }
      }
      return null;
    }

    /** Saves the selected theme mode to the browser's local storage */
    private saveTheme(theme: ThemeMode) {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(this.THEME_STORAGE_KEY, theme);
      }
    }

    /** Toggles between light and dark mode */
    toggleMode() {
      const newMode: ThemeMode =
        this.mode() === 'tds-mode-light' ? 'tds-mode-dark' : 'tds-mode-light';
      this.mode.set(newMode);

      /** Saves the preferred theme user manually setted */
      this.saveTheme(newMode);
    }

  // #endregion

  /**
   * Side menu mobile toggle
   */
  toggleMobileSideMenu() {
    this.mobileNavOpen.set(!this.mobileNavOpen());
  }
}
